import { api_request } from '../axios_client';
import { handleError } from '../common';
import * as Constants from '../constants';

const v1CommonEventHistory = async (params, options) => {
  const resourcePath = `${Constants.PATH.HISTORY.history}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params,
      data: options,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1CommonAttachmentHistory = async (params, options) => {
  const resourcePath = `${Constants.PATH.ATTACHMENT_HISTORY.attachment}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params,
      data: options,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1CommonAttachmentHistoryIdDeletePut = async (id, options) => {
  const resourcePath = `${Constants.PATH.ATTACHMENT_HISTORY.attachment}/${id}${Constants.PATH.ATTACHMENT_HISTORY.delete}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1CommonEventHistoryIdPresignedURL = async (id, options) => {
  const resourcePath = `${Constants.PATH.ATTACHMENT_HISTORY.attachment}/${id}/presigned-url`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      data: options,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

export {
  v1CommonEventHistory,
  v1CommonEventHistoryIdPresignedURL,
  v1CommonAttachmentHistory,
  v1CommonAttachmentHistoryIdDeletePut
};
